import { Input } from '../ui/input';
import { useSmartForm } from './SmartFormContext';
import get from 'lodash/get';
import { Label } from '../ui/label';

const InputField = (props: any) => {
  const {
    name,
    className = "",
    type,
    label,
    containerProps = {},
    ...rest
  } = props;

  const {
    methods: {
      register,
    },
    errors,
  } = useSmartForm();

  const error = get(props.errors, [name, 0], get(errors, [name, 'message'], undefined))

  return (
    <div className={`space-y-2 ${containerProps.className || ""}`}>
      {label && (
        <Label htmlFor={name}>
          {label}
        </Label>
      )}
      <Input
        {...register(name)} 
        {...rest}
        type={type}
        isError={!!error}
        className={className}
      />
      {error && (
        <p
          className="text-sm text-red-600"
        >
          {error}
        </p>
      )}
    </div>
  )
}

export default InputField;